"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetType = void 0;
var TargetType;
(function (TargetType) {
    TargetType["AllAllies"] = "all-allies";
    TargetType["AllEnemies"] = "all-enemies";
    TargetType["None"] = "none";
    TargetType["Self"] = "self";
    TargetType["SingleAlly"] = "single-ally";
    TargetType["SingleEnemy"] = "single-enemy";
})(TargetType || (exports.TargetType = TargetType = {}));
